import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { axiosStudioInstance } from "../../service/axiosStudioConfig";
import oper from '../../assets/courseOrg/operations.webp'
import Marketing from '../../assets/courseOrg/marketing.webp'
import Freelancing from '../../assets/courseOrg/freelanc.webp'
import business from '../../assets/courseOrg/business.webp'
import softSkills from '../../assets/courseOrg/softSkills.webp'
import programing from '../../assets/courseOrg/program.webp'
import operEN from '../../assets/courseOrg/operationsEN.png'
import MarketingEN from '../../assets/courseOrg/marketingEN.png'
import FreelancingEN from '../../assets/courseOrg/freelancEN.png'
import businessEN from '../../assets/courseOrg/businessEN.png'
import softSkillsEN from '../../assets/courseOrg/softSkillsEN.png'
import programingEN from '../../assets/courseOrg/programEN.png'
import line from '../../assets/line.webp';
import styles from './TopRanking.module.css'
import ScrollReveal from 'scrollreveal';
import { LazyLoadImage } from "react-lazy-load-image-component";



export default function TopRanking() {
  const [CoursesList, setCoursesList] = useState([]);
  const imageRef = useRef(null);
  const screenWidth = window.innerWidth;

  const { t, i18n } = useTranslation();
  useEffect(() => {
    axiosStudioInstance
      .get(`/organizations`)
      .then((res) => {
        const filteredData = res.data.filter((item) =>
          ["Operations", "Marketing", "Freelancing", "Business_and_Management", "Soft_Skills", "Programming_and_Technology"].includes(item)
        );
        setCoursesList(filteredData);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(imageRef.current, {
      duration: 500,
      distance: screenWidth < 768 ? '0px' : '100px',
      easing: 'ease-in',
      origin: 'left',
      reset: false,
    });
    //eslint-disable-next-line
  }, []);


  return (
    <>
      <div className="container">
        <div className="container my-5" id="topRanking">
          <div className='d-flex flex-column justify-around-center align-items-center my-3'>
            <h2 className={styles.title} >{t("top-ranking")}</h2>
            <LazyLoadImage src={line} alt="underline" className={`${styles.lineWeb} ${styles.lineMobile} `} ref={imageRef} />
          </div>
          <div className="row justify-content-around">
            {CoursesList?.map((courseOrg, index) => {
              return (
                <Link
                  to={`/all-courses?org=${courseOrg.toLowerCase()}`}
                  key={index}
                  style={{ marginBottom: "10px" }}
                  className="col-md-4  col-sm-10   rounded position-relative  d-flex justify-content-around
                  flex-column
                  align-items-center"
                >
                  {courseOrg === "Operations" && <LazyLoadImage alt="Operations" src={i18n.language === "ar" ? oper : operEN} />}
                  {courseOrg === "Marketing" && <LazyLoadImage alt="Marketing" src={i18n.language === "ar" ? Marketing : MarketingEN} />}
                  {courseOrg === "Freelancing" && <LazyLoadImage alt="Freelancing" src={i18n.language === "ar" ? Freelancing : FreelancingEN} />}
                  {courseOrg === "Business_and_Management" && <LazyLoadImage alt="Business_and_Management" src={i18n.language === "ar" ? business : businessEN} />}
                  {courseOrg === "Soft_Skills" && <LazyLoadImage alt="Soft_Skills" src={i18n.language === "ar" ? softSkills : softSkillsEN} />}
                  {courseOrg === "Programming_and_Technology" && <LazyLoadImage alt="Programming_and_Technology" src={i18n.language === "ar" ? programing : programingEN} />}
                </Link>
              );
            })}
          </div>
          <div className="d-flex justify-content-center mb-3">
            <Link to="/all-courses">
              <button
                aria-label="button to be clicked"
                aria-labelledby="button to be clicked"
                className={`btn btn-primary ${styles.btn_see_all}`}
              >
                {t("View All")}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
